import { render, staticRenderFns } from "./ModalCapacitaciones.vue?vue&type=template&id=aecf0fa4&"
import script from "./ModalCapacitaciones.vue?vue&type=script&lang=ts&"
export * from "./ModalCapacitaciones.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCapacitaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports